import { createStore, combineReducers } from "redux";
import navbarStyle from "./ducks/navbarStyle";
import navbarActive from "./ducks/navbarActive";

const reducers = combineReducers({
    navStyle: navbarStyle,
    navStatus: navbarActive
})

export const store = createStore(reducers);